import Pages from "./pages"

export const DEFAULT_FACILITY_ROUTE = Pages.Facilities
export const DEFAULT_GIFT_CREDIT_ROUTE = Pages.GiftCredit
export const DEFAULT_GIFT_CREDIT_FLOW = "/dashboard/gift-credit/static-flow"
export const DEFAULT_GIFT_CREDIT_INSTALMENT = "/dashboard/gift-credit/instalments"
export const DEFAULT_GIFT_CREDIT_UPDATE = "/dashboard/gift-credit/update"

export enum CONTRACT_TYPES {
  GIFT_CREDIT = "GIFT_CREDIT",
  FACILITY = "FACILITY"
}